// tslint:disable
import { Injector, Component } from "@angular/core";

import {
  CMFormBrowse2Component,
  CMFormPesquisaComponent,
} from "./../../@cmcore/component";
import { MarketplaceEditComponent } from "./marketplace-edit.component";

@Component({
  selector: "marketplace-browse",
  templateUrl:
    "./../../@cmcore/component/cmform/cmform-browse/cmform-browse2.component.html",
  styleUrls: [
    "./../../@cmcore/component/cmform/cmform-browse/cmform-browse2.component.scss",
  ],
})
export class MarketplaceBrowseComponent extends CMFormBrowse2Component {
  static defaultColumns = [
    { field: "codigo", caption: "Código", width: "100" },
    { field: "nome", caption: "Nome", filter: true },
  ];

  constructor(_injector: Injector) {
    super(_injector);
    this.controllerName = "marketplace";
    this.fixedFooterFormEdit = false;
    this.formEditComponent = MarketplaceEditComponent;
    this.columns = MarketplaceBrowseComponent.defaultColumns;
  }

  getTitle() {
    return "Marketplace";
  }

  static pesquisa(sender: any, target: any, targetProp: any = undefined) {
    if (target) {
      CMFormPesquisaComponent.defaultPesquisa(
        sender,
        "marketplace",
        "Pesquisa de Marketplace",
        MarketplaceBrowseComponent.defaultColumns,
        target,
        targetProp,
        "codigo"
      );
    }
  }
}
